export interface BaseError {
    type: 'ApiError';
    code: ApiErrorCode;
    message: string;
    details?: any;
  }
  
export enum ApiErrorCode {
  UNAUTHORIZED="UNAUTHORIZED",
  GENERIC_ERROR="GENERIC_ERROR",

  PAYMENT_PROVIDER_VALIDATION_ERROR="PAYMENT_PROVIDER_VALIDATION_ERROR",
  PAYMENT_PROVIDER_ERROR="PAYMENT_PROVIDER_ERROR",


  //User, link, offer reasons
    INVALID_USER="INVALID_USER",
    INVALID_LINK="INVALID_LINK",
    INVALID_OFFER="INVALID_OFFER",

    INVALID_TAX_NR="INVALID_TAX_NR",

    //Group reasons
    INVALID_GROUP="INVALID_GROUP",
    INVALID_CHAT="INVALID_CHAT",
    INVALID_MSG_CONTENT="INVALID_MSG_CONTENT",

    USER_ALREADY_MEMBER="USER_ALREADY_MEMBER",
    USER_DOESNT_OWN_GROUP="USER_DOESNT_OWN_GROUP",
    GROUP_HAS_NO_INVITE="GROUP_HAS_NO_INVITE",
    GROUP_HAS_MISSING_PRODUCT="GROUP_HAS_MISSING_PRODUCT",

    INVALID_PRODUCT="INVALID_PRODUCT",

    //Product reasons
    USER_DOESNT_OWN_PRODUCT="USER_DOESNT_OWN_PRODUCT",

    INVALID_PAYMENT_RETURN_URL="INVALID_PAYMENT_RETURN_URL",
}
